import type { AxiosRequestConfig } from 'axios';
import { post } from '@/utils/network/axios-helper';
import type { IParamsType } from '@/utils/ctype';
import type { ISaveWritingAnswerList, IWritingContent } from './type';
import { EXAM_REQUEST_TIMEOUT_MS } from './start';

export const getWritingContent = (params: IParamsType) => {
  return post<IWritingContent>('/api/simulate/get-writing-info', params);
};

export const getAnswerList = (params: IParamsType) => {
  return post('/api/simulate/get-writing-draft-info', params);
};

export const saveAnswerList = (params: ISaveWritingAnswerList, config?: AxiosRequestConfig) => {
  return post('/api/simulate/save-writing-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const submitAnswer = (params: IParamsType, config?: AxiosRequestConfig) => {
  return post('/api/simulate/finished-writing', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};
